import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { forwardRef } from 'react';
import styles from './RangeInput.module.css';
import { type RangeInputProps } from './types';
const RangeInput = forwardRef<HTMLInputElement, RangeInputProps>(function RangeInput(t0, ref) {
  const $ = _c(12);
  let className;
  let fullWidth;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      fullWidth,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = fullWidth;
    $[3] = props;
  } else {
    className = $[1];
    fullWidth = $[2];
    props = $[3];
  }
  const t1 = fullWidth && fullWidth !== "mobile-only";
  const t2 = fullWidth && fullWidth === "mobile-only";
  let t3;
  if ($[4] !== className || $[5] !== t1 || $[6] !== t2) {
    t3 = classNames(styles.rangeInput, className, {
      "fullWidth": t1,
      "fullWidthOnMobile": t2
    });
    $[4] = className;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props || $[9] !== ref || $[10] !== t3) {
    t4 = <input ref={ref} {...props} className={t3} type="range" />;
    $[8] = props;
    $[9] = ref;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
});
export default RangeInput;